<div class="hand">
  <app-avatar
    *ngIf="icon"
    [icon]="icon"
    [iconSize]="25"
    [iconColor]="iconColor"
    [containerSize]="50"
    [containerColor]="iconBgColor"
  ></app-avatar>
  <div>
    <div class="main-info">
      <h2 class="title">{{ title }}</h2>
    </div>
    <ng-content select="[content]"></ng-content>
  </div>
</div>
<div class="hand">
  <ng-content select="[actions]"></ng-content>
</div>
